export const GET_LEDGER_ACCOUNTS = gql`
    query GetLedgerAccounts {
        getLedgerAccounts {
            value
            label
        }
    }
`;
